import axios from "axios";

export const generateUser = async () => await axios.post('/super/users/assign-users')

